import { render, staticRenderFns } from "./OrderVersions.vue?vue&type=template&id=3a914874&scoped=true"
import script from "./OrderVersions.vue?vue&type=script&lang=js"
export * from "./OrderVersions.vue?vue&type=script&lang=js"
import style0 from "./OrderVersions.vue?vue&type=style&index=0&id=3a914874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a914874",
  null
  
)

export default component.exports